import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import addSingleInterior from 'rangeConfig/shared/behaviors/addSingleInterior';
import {
  matchInteriorsToFramePlacement,
  matchInteriorsToFrames
} from 'rangeConfig/smastad/filters/mainMenuProductFilters';

const interiorsProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'typeName',
  behaviors: {
    productClicked: [addSingleInterior],
    productDropped: [addSingleInterior]
  },
  cluster: ['type', 'typeName'],
  productFilters: [matchInteriorsToFrames, matchInteriorsToFramePlacement],
  sortOrder: [],
  categories: [
    {
      id: 'interiors',
      products: [
        { path: 'type', value: ProductType.SMASTAD_CLOTH_RAIL_40 },
        { path: 'type', value: ProductType.SMASTAD_CLOTH_RAIL_ASM },
        { path: 'type', value: ProductType.SMASTAD_CLOTH_RAIL_55_W_HOOKS_ASM }
      ]
    },
    {
      id: 'interiors',
      products: [{ path: 'type', value: ProductType.SMASTAD_RAIL_STRIP_W_HOOKS_ASM }],
      cluster: ['type']
    },
    {
      id: 'interiors',
      products: [{ path: 'type', value: ProductType.SMASTAD_SHELF }]
    },
    {
      id: 'interiors',
      products: [{ path: 'type', value: ProductType.SMASTAD_WIRE_BASKET_ASM }]
    }
  ]
};

export default interiorsProductListConfig;
